// select control
import { selectRequiredControl } from '../../core/common/select/select-required';

// Enums and Interface
import { Field } from '../../../../models/common/forms/form-field-config';

// Utils
import { FormControlUtil } from '../../../../core/utils/form-control';
import { MasterService } from '../../../../state/master/services/master.service';

/**
 * Constant for the area dropdown control
 */
export const areaSelectControl: Field = FormControlUtil.mergeFormControl(selectRequiredControl, {
  key: 'area',
  templateOptions: FormControlUtil.mergeFormControl(selectRequiredControl.templateOptions, {
    label: MasterService.masterBusinessLabel.Area,
    bindLabel: 'area_name',
    bindValue: 'area_id',
  }),
});
